"use client";
import Accordion from "react-bootstrap/Accordion";
import "./MCA_Program_Structure.css";

export default function MCA_Program_Structure() {
  return (
    <section className="mca-program py-5">
      <div className="container">
        <h2 className="text-center fw-bold mb-4">MCA Program Structure</h2>

        <Accordion defaultActiveKey="0" className="accordion-section">
            
          {/* FOUNDATION */}
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              Foundation Core: Semester I & II (Common for all)
            </Accordion.Header>

            <Accordion.Body>
              <div className="sem-title">Semester I</div>

              <table class="course-table">
                <thead>
                  <tr>
                    <th>Course Code</th>
                    <th>Course Title</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span class="course-code">OMCA 101</span>
                    </td>
                    <td>Computer Organization and Architecture</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCA 102</span>
                    </td>
                    <td>Data Structure Using C</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCA 103</span>
                    </td>
                    <td>Object Oriented Programming Using C++</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCA 104</span>
                    </td>
                    <td>Discrete Mathematics and Combinatorics</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCA 105</span>
                    </td>
                    <td>Lab - OOPS using C++</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCA 106</span>
                    </td>
                    <td>Business Communication</td>
                  </tr>
                </tbody>
              </table>

              <div className="sem-title">Semester II</div>

              <table class="course-table">
                <thead>
                  <tr>
                    <th>Course Code</th>
                    <th>Course Title</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span class="course-code">OMCA 201</span>
                    </td>
                    <td>Database Management System</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCA 202</span>
                    </td>
                    <td>Full Stack Web Development</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCA 203</span>
                    </td>
                    <td>Software Engineering</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCA 204</span>
                    </td>
                    <td>Data Communication and Computer Networks</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCA 205</span>
                    </td>
                    <td>Lab - DBMS</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCA 206</span>
                    </td>
                    <td>Lab - Full Stack Web Development</td>
                  </tr>
                </tbody>
              </table>

              <div className="research-badge">
                Common foundation for all MCA specializations (Sem III & IV
                elective streams).
              </div>
            </Accordion.Body>
          </Accordion.Item>

          {/* SPECIALIZATIONS */}
          <Accordion.Item eventKey="1">
            <Accordion.Header>
              Specializations (Semester III & IV)
            </Accordion.Header>

            <Accordion.Body>
              <div class="inner-course-grid">
                <div class="specialization-grid">
                  <div class="spec-card">Artificial Intelligence & ML</div>
                  <div class="spec-card">Blockchain Technology</div>
                  <div class="spec-card">Business Analytics</div>
                  <div class="spec-card">Digital Marketing</div>
                  <div class="spec-card">FinTech</div>
                </div>
                <p className="spec_text">
                  Each specialization includes core Java + Python analytics lab,
                  along with domain-specific subjects. Explore detailed
                  semester-wise breakdown below.
                </p>
              </div>
            </Accordion.Body>
          </Accordion.Item>

          {/* AI ML */}
          <Accordion.Item eventKey="2">
            <Accordion.Header>
              Artificial Intelligence & Machine Learning
            </Accordion.Header>

            <Accordion.Body>
              <div className="sem-title">Semester III - AI & ML</div>
              <table class="course-table">
                <tbody>
                  <tr>
                    <td>
                      <span class="course-code">OMCAAIML 301</span>
                    </td>
                    <td>
                      Basics of Artificial Intelligence &amp; Machine Learning
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCAAIML 302</span>
                    </td>
                    <td>Machine Learning</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCAAIML 303</span>
                    </td>
                    <td>Performing Analytics with Python</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCAAIML 304</span>
                    </td>
                    <td>Core and Advance Java</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCAAIML 305</span>
                    </td>
                    <td>Business Intelligence</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCAAIML 306</span>
                    </td>
                    <td>Lab – Java and Python Programming</td>
                  </tr>
                </tbody>
              </table>

              <div className="sem-title">Semester IV - AI & ML</div>
              <table class="course-table">
                <tbody>
                  <tr>
                    <td>
                      <span class="course-code">OMCAAIML 401</span>
                    </td>
                    <td>Application of AI in Business</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCAAIML 402</span>
                    </td>
                    <td>Introduction to Deep Learning</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCAAIML 403</span>
                    </td>
                    <td>R-Programming for Data Analysis and Visualization</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCARP 404</span>
                    </td>
                    <td>Research Project</td>
                  </tr>
                </tbody>
              </table>
            </Accordion.Body>
          </Accordion.Item>

          {/* BLOCKCHAIN */}
          <Accordion.Item eventKey="3">
            <Accordion.Header>Blockchain Technology</Accordion.Header>

            <Accordion.Body>
              <div className="sem-title">Semester III - Blockchain</div>
              <table class="course-table">
                <tbody>
                  <tr>
                    <td>
                      <span class="course-code">OMCABT 301</span>
                    </td>
                    <td>Basics of Blockchain Technology</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCABT 302</span>
                    </td>
                    <td>Cryptography and Information Security</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCABT 303</span>
                    </td>
                    <td>Performing Analytics with Python</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCABT 304</span>
                    </td>
                    <td>Core and Advance Java</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCABT 305</span>
                    </td>
                    <td>Blockchain and FinTech</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCABT 306</span>
                    </td>
                    <td>Lab – Java and Python Programming</td>
                  </tr>
                </tbody>
              </table>

              <div className="sem-title">Semester IV - Blockchain</div>
              <table class="course-table">
                <tbody>
                  <tr>
                    <td>
                      <span class="course-code">OMCABT 401</span>
                    </td>
                    <td>
                      Enterprise Blockchain Applications &amp; Hyperledger
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCABT402</span>
                    </td>
                    <td>Design and Development of Blockchain Applications</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCABT 403</span>
                    </td>
                    <td>Blockchain Technology and Management</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCARP 404</span>
                    </td>
                    <td>Research Project</td>
                  </tr>
                </tbody>
              </table>
            </Accordion.Body>
          </Accordion.Item>

          {/*  Business Analytics */}
          <Accordion.Item eventKey="4">
            <Accordion.Header> Business Analytics</Accordion.Header>

            <Accordion.Body>
              <div className="sem-title">Semester III - Business Analytics</div>
              <table class="course-table">
                <tbody>
                  <tr>
                    <td>
                      <span class="course-code">OMCABA301</span>
                    </td>
                    <td>Business Analytics-I</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCABA 302</span>
                    </td>
                    <td>Business Analytics-II</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCABA 303</span>
                    </td>
                    <td>Performing Analytics with Python</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCABA 304</span>
                    </td>
                    <td>Core and Advance Java</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCABA 305</span>
                    </td>
                    <td>Business Statistics and Econometrics</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCABA 306</span>
                    </td>
                    <td>Lab – Java and Python Programming</td>
                  </tr>
                </tbody>
              </table>

              <div className="sem-title">Semester IV - Business Analytics</div>
              <table class="course-table">
                <tbody>
                  <tr>
                    <td>
                      <span class="course-code">OMCABA 401</span>
                    </td>
                    <td>Business Mathematics &amp; Optimization Techniques</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCABA402</span>
                    </td>
                    <td>Python Programming for data visualization</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCABA 403</span>
                    </td>
                    <td>R programming for Data analysis and Visualization</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCARP 404</span>
                    </td>
                    <td>Research Project</td>
                  </tr>
                </tbody>
              </table>
            </Accordion.Body>
          </Accordion.Item>

          {/*   Digital Marketing */}
          <Accordion.Item eventKey="5">
            <Accordion.Header> Digital Marketing</Accordion.Header>

            <Accordion.Body>
              <div className="sem-title">Semester III - Digital Marketing</div>
              <table class="course-table">
                <tbody>
                  <tr>
                    <td>
                      <span class="course-code">OMCADM301</span>
                    </td>
                    <td>Introduction to Digital Marketing</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCADM 302</span>
                    </td>
                    <td>Search Engine Optimization</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCADM 303</span>
                    </td>
                    <td>Performing Analytics with Python</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCADM 304</span>
                    </td>
                    <td>Core and Advance Java</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCADM 305</span>
                    </td>
                    <td>Social Media Marketing</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCADM 306</span>
                    </td>
                    <td>Lab – Java and Python Programming</td>
                  </tr>
                </tbody>
              </table>

              <div className="sem-title">Semester IV - Digital Marketing</div>
              <table class="course-table">
                <tbody>
                  <tr>
                    <td>
                      <span class="course-code">OMCADM 401</span>
                    </td>
                    <td>Product and Brand Management</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCADM 402</span>
                    </td>
                    <td>International Marketing</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCADM 403</span>
                    </td>
                    <td>Web Designing and Content Management (MM)</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCARP 404</span>
                    </td>
                    <td>Research Project</td>
                  </tr>
                </tbody>
              </table>
            </Accordion.Body>
          </Accordion.Item>

          {/*  FinTech */}
          <Accordion.Item eventKey="6">
            <Accordion.Header> FinTech</Accordion.Header>

            <Accordion.Body>
              <div className="sem-title">Semester III - FinTech</div>
              <table class="course-table">
                <tbody>
                  <tr>
                    <td>
                      <span class="course-code">OMCAFT 301</span>
                    </td>
                    <td>FinTech Management</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCAFT 302</span>
                    </td>
                    <td>Financial Institutions and Banking</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCAFT 303</span>
                    </td>
                    <td>Performing Analytics with Python</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCAFT 304</span>
                    </td>
                    <td>Core and Advance Java</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCAFT 305</span>
                    </td>
                    <td>E-Commerce &amp; Global Financial Trends</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCAFT 306</span>
                    </td>
                    <td>Lab – Java and Python Programming</td>
                  </tr>
                </tbody>
              </table>

              <div className="sem-title">Semester IV - FinTech</div>
              <table class="course-table">
                <tbody>
                  <tr>
                    <td>
                      <span class="course-code">OMCAFT 401</span>
                    </td>
                    <td>Blockchain and FinTech</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCAFT402</span>
                    </td>
                    <td>Cyber Laws &amp; Hacking</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCAFT 403</span>
                    </td>
                    <td>Quantitative Methods in Project Management</td>
                  </tr>
                  <tr>
                    <td>
                      <span class="course-code">OMCARP 404</span>
                    </td>
                    <td>Research Project</td>
                  </tr>
                </tbody>
              </table>
            </Accordion.Body>

          </Accordion.Item>
        </Accordion>
      </div>
    </section>
  );
}
